import { Controller } from "@hotwired/stimulus"

// Live preview of coverage warning banners on the /configuration page.
// Listens for input events on copy override fields and updates
// the corresponding preview banner title/body in real time.
export default class extends Controller {
  static targets = [
    "resultsTitle", "resultsBody",
    "preExistingTitle", "preExistingBody",
    "limitationTitle", "limitationBody",
    "combinedTitle", "combinedBody"
  ]

  static values = {
    defaultResultsTitle: String,
    defaultResultsBody: String,
    defaultPreExistingTitle: String,
    defaultPreExistingBody: String,
    defaultLimitationTitle: String,
    defaultLimitationBody: String,
    defaultCombinedTitle: String,
    defaultCombinedBody: String
  }

  connect() {
    this.element.addEventListener("input", this.handleInput.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.handleInput.bind(this))
  }

  handleInput(event) {
    const field = event.target
    const name = field.name || ""

    if (name.includes("coverage_warning_results_title")) {
      this.updateTarget("resultsTitle", field.value, this.defaultResultsTitleValue)
    } else if (name.includes("coverage_warning_results_body")) {
      this.updateTarget("resultsBody", field.value, this.defaultResultsBodyValue)
    } else if (name.includes("pre_existing_condition_price_warning_title")) {
      this.updateTarget("preExistingTitle", field.value, this.defaultPreExistingTitleValue)
    } else if (name.includes("pre_existing_condition_price_warning_body")) {
      this.updateTarget("preExistingBody", field.value, this.defaultPreExistingBodyValue)
    } else if (name.includes("coverage_limitation_price_warning_title")) {
      this.updateTarget("limitationTitle", field.value, this.defaultLimitationTitleValue)
    } else if (name.includes("coverage_limitation_price_warning_body")) {
      this.updateTarget("limitationBody", field.value, this.defaultLimitationBodyValue)
    } else if (name.includes("combined_coverage_price_warning_title")) {
      this.updateTarget("combinedTitle", field.value, this.defaultCombinedTitleValue)
    } else if (name.includes("combined_coverage_price_warning_body")) {
      this.updateTarget("combinedBody", field.value, this.defaultCombinedBodyValue)
    }
  }

  updateTarget(targetName, value, defaultValue) {
    const targetEl = this[`${targetName}Target`]
    if (targetEl) {
      targetEl.textContent = value.trim() || defaultValue
    }
  }
}
